// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleNotesButton_deviceButton__0ThRN","icon":"ToggleNotesButton_icon__5iMdh"};